import React from 'react';
import classNames from 'classnames';

const PreviewImage = ({ image, category, className }) => {
  return (
    <div
      className={classNames(
        'bg-neutral-100 w-[100px] min-h-full overflow-hidden shrink-0 rounded-md',
        className,
      )}
    >
      {image ? (
        <img className="w-full h-full object-cover" src={image} alt="" />
      ) : (
        <div
          className="w-[100px] h-full overflow-hidden flex justify-center items-center shrink-0 rounded-md"
          style={{ backgroundColor: category.color || 'fuchsia' }}
        >
          <span
            className={`gys gys-${category.name} text-[50px] text-white`}
          ></span>
        </div>
      )}
    </div>
  );
};

export default PreviewImage;
